import React from "react";
import DynamicLayout from "../../layout/DynamicLayout";

const DashboardChurch = () => {
  return (
    <DynamicLayout>
      <div className="w-11/12 mx-auto pt-28 pb-20">
        <h1 className="text-4xl font-bold">Tableau de bord MoMo4Church</h1>
      </div>
    </DynamicLayout>
  );
};

export default DashboardChurch;
